{
  "actionWithDelay": "Attendere {{seconds}}s, poi {{action}}",
  "areYouSureYouWantToDisconnectTheseDevices": "Vuoi davvero disconnettere questi dispositivi?",
  "changesFrom": "Modifiche da:",
  "connectDevices": "Connetti dispositivi",
  "newConnection": "Nuova connessione",
  "connectedToTitle": "Connesso a:",
  "connectionsWithConnectionCount": "{{connectionCount}} Connessione(i)",
  "connectedToWithDeviceCount": "Connesso a: {{deviceCount}}",
  "connectionsListTitle": "Connessioni del dispositivo",
  "createTitle": "Nuova connessione dispositivo",
  "deleteConnection": "Elimina connessione",
  "deviceConnectionsListEmpty": "Non sono ancora state create connessioni tra dispositivi. Tocca \"Collega dispositivi\" per iniziare.",
  "disconnect": "Disconnettersi",
  "notificationsDisabled": "Notifiche disabilitate per la connessione",
  "notificationsEnabled": "Notifiche abilitate per la connessione",
  "selectedConnectionTitle": "Connessione del dispositivo",
  "sendANotificationWhen": "Invia una notifica quando...",
  "sendNotificationsToUsers": "Notifiche:",
  "source": "Fonte",
  "target": "Bersaglio",
  "targetDevice": "Dispositivo di destinazione"
}
